import React, { useEffect, useState } from 'react';
import { agentLabel } from '../lib/format';
import { activityAge } from '../lib/sessionActivity';
import './SessionActivity.css';

function EventTime({ at, now }) {
  return <time dateTime={at} title={new Date(at).toLocaleString('ru-RU')}>{activityAge(at, now)}</time>;
}

export default function SessionActivity({ activity, session, compact = false, inline = false, error, syncedAt }) {
  const [now, setNow] = useState(Date.now);
  useEffect(() => {
    const timer = setInterval(() => setNow(Date.now()), 15000);
    return () => clearInterval(timer);
  }, []);
  const { counts, active, latest, events } = activity;
  const running = session.status === 'running';
  if (compact) return <div className="session-activity-summary">
    <span className="session-activity-counts" title="Задачи за всю сессию">
      <span>Готово <strong>{counts.done}</strong></span>
      <span className="session-activity-running-count">{running ? 'В работе' : 'Незавершено'} <strong>{counts.running}</strong></span>
      <span>В очереди <strong>{counts.queued}</strong></span>
      {counts.failed > 0 && <span className="session-activity-errors session-activity-failed-count">С ошибкой <strong>{counts.failed}</strong></span>}
    </span>
    <span className={`session-activity-freshness ${error ? 'session-activity-errors' : ''}`}>
      {error ? 'Данные не обновляются' : latest
        ? <>Событие <EventTime at={latest.at} now={now} /></> : 'Событий пока нет'}
    </span>
  </div>;
  const heading = inline ? (running ? 'В работе'
    : session.status === 'paused' ? 'Работа приостановлена'
    : session.status === 'waiting_for_human' ? 'Нужен ваш ответ'
    : session.status === 'failed' ? 'Работа остановлена'
    : session.status === 'cancelled' ? 'Работа отменена' : 'Подготовка работы')
    : running ? 'Сейчас в работе' : 'Незавершённые задачи';
  if (inline) return <section className="session-activity session-activity-inline" aria-label="Текущая работа">
    <h3>{heading}</h3>
    {error && <p role="alert" className="session-activity-errors">Данные не обновляются. Показано последнее состояние.</p>}
    {active.length === 0 ? <p className="text-muted">{running ? 'Определяю следующий шаг…' : 'Выполняющихся задач нет.'}</p>
      : <ul className="session-active-tasks session-current-tasks">{active.map(task => <li key={task.id}
        title={`${agentLabel(task.assigned_to)} — ${task.objective}\n${task.phase}`}>
        <span className={`session-task-dot${running ? ' is-running' : ''}`} aria-hidden="true" />
        <span className="session-current-task-text"><strong>{agentLabel(task.assigned_to)}</strong>
          <span className="text-muted"> — </span>{(task.objective || '').replace(/\s+/g, ' ').trim()}
        </span>
      </li>)}</ul>}
  </section>;
  return <section className="session-activity" aria-label="Текущая работа">
    <h3>{heading}</h3>
    <p className="session-activity-totals">{running ? 'В работе' : 'Незавершено'}: {counts.running} · Готово: {counts.done} · В очереди: {counts.queued}
      {counts.failed > 0 && <span className="session-activity-errors"> · С ошибкой: {counts.failed}</span>}</p>
    {error && <p role="alert" className="session-activity-errors">Нет связи. Показаны последние загруженные состояния задач.</p>}
    {!running && active.length > 0 && <p className="text-muted">Сохранённое состояние. {session.status === 'paused' ? 'Работа приостановлена.' : 'Сессия сейчас не выполняется.'}</p>}
    {active.length === 0 && <p className="text-muted">{running ? 'Выполняющихся задач пока нет. Следующий шаг появится после планирования.' : 'Выполняющихся задач нет.'}</p>}
    <ul className="session-active-tasks">{active.map(task => <li key={task.id}>
      <div className="session-active-task-heading"><strong>{agentLabel(task.assigned_to)}</strong><span>{task.phase}</span></div>
      <p className="session-active-objective">{task.objective}</p>
      {(task.objective || '').length > 220 && <details className="session-task-description">
        <summary>Полное задание</summary><p>{task.objective}</p>
      </details>}
      <small>{task.started_at ? <>Начата <EventTime at={task.started_at} now={now} /></> : 'Время начала не записано'}
        {task.retry_count > 0 && ` · повторов: ${task.retry_count}`}</small>
    </li>)}</ul>
    <h3>Последние события</h3>
    {events.length === 0 ? <p className="text-muted">События появятся после начала работы.</p>
      : <ol className="session-recent-events">{events.map(event => <li key={event.id}>
        <EventTime at={event.at} now={now} /><span>{event.text}</span>
      </li>)}</ol>}
    <p className="session-activity-sync">{syncedAt ? <>Данные получены <EventTime at={syncedAt} now={now} />. </> : ''}
      Время событий меняется только при новых действиях; запрос модели может занимать несколько минут.</p>
  </section>;
}
